import React from "react";
import { useTranslation } from "react-i18next";
import { renderHomepageMainHeading } from "../highlights/homepageHighlights";
import {
  useTypographyHelpers,
  useColorHelpers,
} from "../../contexts/DesignContext";

// Main Heading Component
const MainHeading = () => {
  const { t } = useTranslation("home");
  const { getInnovationTextClasses } = useColorHelpers();
  const { getPrimaryHeading } = useTypographyHelpers();

  const innovationTextClasses = getInnovationTextClasses();

  return (
    <h1 className={`${getPrimaryHeading("hero")} text-center`}>
      {renderHomepageMainHeading(
        innovationTextClasses,
        t("searchPage.mainHeading.firstLine.prefix"),
        t("searchPage.mainHeading.firstLine.highlight"),
        t("searchPage.mainHeading.secondLine.prefix"),
        t("searchPage.mainHeading.secondLine.highlight"),
      )}
    </h1>
  );
};

// Suggestion Buttons Component
const SuggestionButtons = ({ suggestions }) => {
  const { t } = useTranslation("home");
  const { getUIStyles } = useTypographyHelpers();
  const uiStyles = getUIStyles();
  return (
    <div className="flex flex-wrap justify-center gap-3 mt-8">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => window.open(suggestion.url, "_blank")}
          className={`px-6 py-3 bg-gray-800/30 backdrop-blur border border-gray-600/50 text-gray-300 rounded-full hover:bg-gray-700/50 hover:border-violet-400 hover:text-white transition-all duration-300 ${uiStyles.label} cursor-pointer`}
        >
          {t(`searchPage.suggestions.${suggestion.key}`)}
        </button>
      ))}
    </div>
  );
};

// YouTube Video Component
const YouTubeVideo = () => {
  return (
    <div className="w-full">
      <div className="relative bg-gray-800/30 backdrop-blur border border-gray-700/50 rounded-3xl overflow-hidden shadow-2xl">
        <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
          <iframe
            className="absolute top-0 left-0 w-full h-full border-0"
            src="https://www.youtube.com/embed/J79NnTEi6b4"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

// Main SearchPage Component
export default function SearchPage({ suggestions }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-4xl space-y-8">
        <MainHeading />

        <YouTubeVideo />

        <SuggestionButtons suggestions={suggestions} />
      </div>
    </div>
  );
}
